// Sample
// export const XXX = 'XXX';

// 獲取 prdPageBrandStyle：區分 元鍋John‘s 和 MMM 商品頁的變數
export const GET_PRD_PAGE_BRAND_STYLE = 'GET_PRD_PAGE_BRAND_STYLE';

// 獲取 MMM 廣告
export const GET_MMM_HOME_ADV = 'GET_MMM_HOME_ADV';
export const GET_ZH_MMM_SAUCE_ADV = 'GET_ZH_MMM_SAUCE_ADV';
export const GET_ZH_MMM_NOODLES_ADV = 'GET_ZH_MMM_NOODLES_ADV';
export const GET_ZH_MMM_VIDEOS_ADV = 'GET_ZH_MMM_VIDEOS_ADV';

// 獲取 元鍋John's 廣告
export const GET_JOHNS_HOME_ADV = 'GET_JOHNS_HOME_ADV';

// 獲取正和廣告
export const GET_ZHHOME_ADV = 'GET_ZHHOME_ADV';
export const GET_ZHNOODLES_ADV = 'GET_ZHNOODLES_ADV';
export const GET_ZHSAUCE_ADV = 'GET_ZHSAUCE_ADV';
export const GET_ZHEVALUATE_ADV = 'GET_ZHEVALUATE_ADV';

// common
export const CHANGE_EFFECT_ISLOADING = 'CHANGE_EFFECT_ISLOADING';
export const GET_COMMON_ADV = 'GET_COMMON_ADV';
export const CHANGE_MODAL_SHOW = 'CHANGE_MODAL_SHOW';

// 首頁
export const GET_NEW_INDEX_DATA = 'GET_NEW_INDEX_DATA';
export const GET_HOME_PRODUCTS = 'GET_HOME_PRODUCTS';

// 總覽頁面
export const GET_CLASSIC_PRODUCTS = 'GET_CLASSIC_PRODUCTS';
export const GET_REAL_PRODUCTS = 'GET_REAL_PRODUCTS';
export const GET_GIFT_PRODUCTS = 'GET_GIFT_PRODUCTS';
export const GET_PRODUCTS = 'GET_PRODUCTS';

// login
export const SET_USER_TOKEN = 'SET_USER_TOKEN';
export const LOGIN_FAIL = 'LOGIN_FAIL';

// 註冊
export const SUBMIT_REGISTER_DATA = 'SUBMIT_REGISTER_DATA';
// 獲取手機驗證碼
export const GET_PHONE_CODE = 'GET_PHONE_CODE';

// 購物車-步驟二
// shopping info
export const GET_ADDRESS_BOOK = 'GET_ADDRESS_BOOK';
export const UPDATE_API_RESPONSE = 'UPDATE_API_RESPONSE';

// 个人中心
export const MID_UPDATE_TRPLUS_OTHERALSOLIKEPRODUCT = 'MID_UPDATE_TRPLUS_OTHERALSOLIKEPRODUCT';
export const MID_GET_INDEX_MENU_BRAND_DATA = 'MID_GET_INDEX_MENU_BRAND_DATA';
export const MID_GET_INDEX_MINICART = 'MID_GET_INDEX_MINICART';
export const MID_GET_INDEX_MEMBERPOINTS = 'MID_GET_INDEX_MEMBERPOINTS';
export const MID_ADD_TO_CART = 'MID_ADD_TO_CART';
export const MID_ADD_TO_FAVORITE = 'MID_ADD_TO_FAVORITE';

// 订单相关
export const GET_ORDER_LIST_DETAIL_DATA = 'GET_ORDER_LIST_DETAIL_DATA';
export const SHOW_ORDER_LIST_QUESTIONS_MODAL = 'SHOW_ORDER_LIST_QUESTIONS_MODAL';
export const CLOSE_ORDER_LIST_QUESTIONS_MODAL = 'CLOSE_ORDER_LIST_QUESTIONS_MODAL';
export const SHOW_ORDER_LIST_LOGISTIC_HISTORIES_MODAL = 'SHOW_ORDER_LIST_LOGISTIC_HISTORIES_MODAL';
export const UPDATE_ORDER_LIST_QUESTIONS = 'UPDATE_ORDER_LIST_QUESTIONS';
export const CLOSE_ORDER_LIST_LOGISTIC_HISTORIES_MODAL = 'CLOSE_ORDER_LIST_LOGISTIC_HISTORIES_MODAL';
export const UPDATE_ORDER_LIST_LOGISTIC_HISTORIES = 'UPDATE_ORDER_LIST_LOGISTIC_HISTORIES';
export const GET_ORDER_LIST_DATA = 'GET_ORDER_LIST_DATA';

// 购物车
export const UPDATE_CART_LIST_DATA = 'UPDATE_CART_LIST_DATA';
export const UPDATE_MINICARTDATA_DATA = 'UPDATE_MINICARTDATA_DATA';
export const UPDATE_IS_SHOW_COUPON_LIST_MODAL = 'UPDATE_IS_SHOW_COUPON_LIST_MODAL';

/** 產品詳情頁 相關 product */
// 獲取產品信息
export const GET_PRODUCT_DATA = 'GET_PRODUCT_DATA';
// 更新曾經瀏覽過產品信息
export const UPDATE_SIMPLEPRODUCTLIST = 'UPDATE_SIMPLEPRODUCTLIST';
// export const GET_POINT_OF_SERVICES = 'GET_POINT_OF_SERVICES';
// export const GET_COUPON_LIST_FOR_PRODUCT = 'GET_COUPON_LIST_FOR_PRODUCT';
// export const UPDATE_DELIVERY_MODE_CODE = 'UPDATE_DELIVERY_MODE_CODE';
// 返回商品code
export const UPDATE_REQUEST_PRODUCT_CODE = 'UPDATE_REQUEST_PRODUCT_CODE';
// export const UPDATE_REQUEST_CHANGE_POINT = 'UPDATE_REQUEST_CHANGE_POINT';
// 改變商品數量
export const UPDATE_REQUEST_QTY = 'UPDATE_REQUEST_QTY';
// 返回購物車path
export const UPDATE_REQUEST_CATE_PATH = 'UPDATE_REQUEST_CATE_PATH';
// export const UPDATE_REQUEST_DELIVERY_MODE = 'UPDATE_REQUEST_DELIVERY_MODE';
// export const UPDATE_REQUEST_DELIVERY_COST = 'UPDATE_REQUEST_DELIVERY_COST';
// 優惠加購商品列表
export const UPDATE_REQUEST_ADDITIONAL_PURCHASES = 'UPDATE_REQUEST_ADDITIONAL_PURCHASES';
// 更新加入購物車的response
export const UPDATE_ADD_TO_CART_RESPONSE = 'UPDATE_ADD_TO_CART_RESPONSE';
// 異常模式
export const SHOW_EXCEPTION_MODAL = 'SHOW_EXCEPTION_MODAL';
export const CLOSE_EXCEPTION_MODAL = 'CLOSE_EXCEPTION_MODAL';
// 獲取後台返回信息
export const UPDATE_API_RESPONSE_MESSAGE = 'UPDATE_API_RESPONSE_MESSAGE';

// 開啟訂單詳細記錄彈出視窗
export const SHOW_ORDER_DETAIL_RETURN_RECORDS_MODAL = 'SHOW_ORDER_DETAIL_RETURN_RECORDS_MODAL';
// 關閉訂單詳細記錄彈出視窗
export const CLOSE_ORDER_DETAIL_RETURN_RECORDS_MODAL = 'CLOSE_ORDER_DETAIL_RETURN_RECORDS_MODAL';
// 更新訂單詳細記錄
export const UPDATE_ORDER_DETAIL_RETURN_RECORDS = 'UPDATE_ORDER_DETAIL_RETURN_RECORDS';
// 更新銀行代號modal開啟狀態
export const SHOW_ORDER_DETAIL_BANK_MODAL = 'SHOW_ORDER_DETAIL_BANK_MODAL';
// 更新顯示退貨物流彈出視窗顯示
export const SHOW_RETURN_LOGISTIC_MODAL = 'SHOW_RETURN_LOGISTIC_MODAL';
// 更新顯示退貨物流彈出視窗資料
export const UPDATE_RETURN_LOGISTIC_MODAL_DATA = 'UPDATE_RETURN_LOGISTIC_MODAL_DATA';
// 更新約配退貨彈出視窗modal開啟狀態
export const SHOW_RETURN_REQUESTB2B_MODAL = 'SHOW_RETURN_REQUESTB2B_MODAL';
// 取得訂單詳細頁資料
export const GET_ORDER_DETAIL_DATA = 'GET_ORDER_DETAIL_DATA';
// 訂單詳細頁確認狀態是否改變
export const POST_CHECK_REFRESH_ORDER = 'POST_CHECK_REFRESH_ORDER';
// 改變訂單退訂單狀態
export const POST_CHECK_RETURN_ENTRYNUMBERS = 'POST_CHECK_RETURN_ENTRYNUMBERS';
// 更新重整訂單狀態flag
export const UPDATE_REFRESH_RETURN_FLAG = 'UPDATE_REFRESH_RETURN_FLAG';
// 更新退款銀行代碼
export const UPDATE_RETURN_BANKID = 'UPDATE_RETURN_BANKID';
// 取得約配商品退貨紀錄
export const GET_RETURN_REQUESTB2B = 'GET_RETURN_REQUESTB2B';

// 获取折扣卷
export const UPDATE_COUPON_LIST_DATA = 'UPDATE_COUPON_LIST_DATA';
export const GET_UPDATE_COUPON_LIST_DATA = 'GET_UPDATE_COUPON_LIST_DATA';
